"use client";

import { OffersOffer } from '@/services/dataTypes';
import React, { useState } from 'react';
import { filterOfferBanners, getBannerDimensions } from '@/constants/hooks';
import Banner from './Banner';
import Spinner from 'react-bootstrap/Spinner';

interface Props {
    bannerResponse: OffersOffer[];
    domain: string;
    mer_slug: string;
    slug_type: string;
}

const VerticalPromotionOfferBanner = ({ bannerResponse, domain, mer_slug, slug_type }: Props) => {
    const filtered = filterOfferBanners(bannerResponse, 50, 2000, 65, 2000);
    const [visibleCount, setVisibleCount] = useState(6);
    const [loading, setLoading] = useState(false);

    const handleShowMore = () => {
        setLoading(true);
        setTimeout(() => {
            setVisibleCount(prev => prev + 6);
            setLoading(false);
        }, 300);
    };

    if (!filtered || filtered.length === 0) return null;

    const displayedBanners = filtered.slice(0, visibleCount);
    const hasMore = visibleCount < filtered.length;

    return (
        <div className="bg-white rounded-xl p-6 border border-[#E5E7EB] shadow-sm">
            <h4 className="text-lg font-bold text-[#1E3A5F] mb-4 pb-3 border-b border-[#E5E7EB] text-center">
                Banner <span className="text-[#F97316]">Offers</span>
            </h4>

            <div className="flex flex-col gap-3 mb-6">
                {displayedBanners.map((offer_data, i) => {
                    const dimension = getBannerDimensions(offer_data);
                    return (
                        <Banner
                            key={i}
                            data={offer_data}
                            height={dimension?.height}
                            mer_slug={mer_slug}
                            slug_type={slug_type}
                            domain={domain}
                            width={dimension?.width}
                        />
                    );
                })}
            </div>

            {hasMore && (
                <div className="mt-4">
                    <button
                        onClick={handleShowMore}
                        className="w-full py-2.5 px-4 rounded-lg bg-[#F8FAFC] border border-[#E5E7EB] text-sm font-semibold text-[#111827] hover:bg-[#F97316] hover:text-white hover:border-[#F97316] transition-all flex items-center justify-center gap-2"
                    >
                        {loading ? <Spinner size="sm" animation="border" /> : "Show More"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default VerticalPromotionOfferBanner;
